import { render, staticRenderFns } from "./FakeLogin.vue?vue&type=template&id=7715a06e&"
import script from "./FakeLogin.vue?vue&type=script&lang=js&"
export * from "./FakeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports